export default __webpack_public_path__ + "static/DisplayHDR-400-TrueBlack-61f61b06f3ec338390eb387b166bddb1.png";